import React, { useRef } from 'react';
import Image from 'next/image';
import { useScroll, useTransform, motion } from 'framer-motion';

export default function Intro() {
  const container = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: container,
    offset: ['start start', 'end start']
  });

  const y = useTransform(scrollYProgress, [0, 1], ['0vh', '20vh']);

  return (
    <div className="h-auto overflow-hidden">
      <motion.div ref={container} style={{ y }} className="relative ">
        <Image
          width={2500}
          height={2000}
          src="https://media.thespeechclinic.ae/website/images/school-readiness/SCE-16.jpg"
          alt="Therapy Gallery"
          style={{ objectFit: 'cover' }}
        />

        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-white text-center text-2xl sm:text-4xl md:text-8xl font-medium drop-shadow-lg">
            See Therapy in Action
          </h1>
        </div>
      </motion.div>
    </div>
  );
}
